import React, { Component } from 'react';
import Dialog from '../../../../commonModules/interface/Dialog';
import { isEmpty, size } from "lodash";
import { TableRow, TableCell, Button, TableHead, TableBody, Card, Grid, Box, FormControlLabel, FormGroup, Switch, IconButton } from '@material-ui/core';
import { TableLayout } from '../containers/Layout';
import { EditRounded, MoreVertRounded, SearchRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import InputText, { InputSelect, InputSelectNative } from '../../../../commonModules/interface/form-input-inline.jsx';

class ListClient extends Component {
    state = { 
        single:{
            id:"", 
            name: "",
        },
        // searchClient: "",
    }

    displayList = () => {
        const { CLIENTS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(CLIENTS)){
            let filteredList = this.props.getFilteredList()
            rows = size(filteredList)
            tab = this.createClientList(filteredList)
        }
        return [tab, rows]
    }  
        
    createClientList = (list) => { // table
        const { rowsPerPage, currentPage } = this.props
        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( client => (
            <TableRow key={client.id} hover >
                <TableCell>{client.client_paygo_id?"Installation":client.client_type}</TableCell>
                <TableCell onClick={ () => this.props.handleSingle(client) }>{client.client_paygo_id ? client.client_lastname: client.client_lastname+" "+client.client_firstname}</TableCell>                
                <TableCell onClick={ () => this.props.handleSingle(client) }>{client.client_paygo_id ?client.client_firstname:""}</TableCell>
                <TableCell onClick={ () => this.props.handleSingle(client) }>{client.client_address}</TableCell>                
                <TableCell >
                        {client.client_city}
                </TableCell>                
                <TableCell>
                {!client.client_paygo_id &&
                    <IconButton color="primary" onClick={() => this.props.handleUpdate(client)}>
                        <EditRounded />
                    </IconButton>
                }
                </TableCell>                
            </TableRow>
        ))         
    }
    
    render() {
        console.log("[STATE] List Clients ",this.state);

        let list = this.displayList()
        return (
            <React.Fragment>
                {/* <Card title="Recherche"> */}
                {/* </Card> */}
                {!isEmpty(list[0]) &&                     
                    <TableLayout>
                        <TableHead>
                            <TableRow style={{ textAlign: "center"}}>
                                <TableCell component="th">Typologie</TableCell>
                                <TableCell component="th">Nom</TableCell>
                                <TableCell component="th">Paygo ID</TableCell>
                                <TableCell component="th">Adresse</TableCell>
                                <TableCell component="th">Ville</TableCell>
                                <TableCell component="th">Modifier</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list[0]}
                        </TableBody>
                        <TableFooterPagination
                            colSpan={6}
                            count={list[1]} 
                            onChangePage={this.props.onChangePage} 
                            initialPage={this.props.currentPage || 0} 
                        />
                    </TableLayout>

                } 

                {isEmpty(list[0]) && 
                    <div className="text-center">
                        <h5>Pas de client</h5> 
                        cliquez sur 
                        <Button 
                            variant="contained"
                            color="secondary"
                            onClick={ this.props.handleNew}
                        >
                            Nouveau
                        </Button> pour entrer un nouveau client
                    </div>
                }
            </React.Fragment>

        );
    }
}

export default ListClient;